import main from "./main";
import mindmapAPI from './mindmapAPI.js'

export default {
    main,mindmapAPI
};
